export default "__VITE_ASSET__D4o2pBw1__"